export default __webpack_public_path__ + "static/media/logo11.18edb601.png";